
import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/main'
import Overlay from '@/components/Overlay.vue'
import Swal from 'sweetalert2'

@Component({
  components: { Overlay }
})
export default class Register extends Vue {
  loading = false
  name = ''
  email = ''
  phone_country_code = '52'
  phone = ''
  career = ''
  otherCareer = ''
  incomplete = true
  countries: Array<any> = []
  careers: Array<any> = []
  token = ''

  mounted () {
    this.validateQueryParam()
    this.setCountryCodes()
    this.setCareers()
  }

  validateQueryParam () {
    const token = this.$route.query.t
    const email = this.$route.query.e
    if (token && email) {
      this.email = email.toString()
      this.token = token.toString()
      this.setUserData()
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error intentalo mas tarde :D'
      })
    }
  }

  async setCountryCodes () {
    this.loading = true
    const [error, response] = await MainService.getCountryCodes()
    this.loading = false
    if (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error al obtener los paises'
      })
      return
    }
    this.countries = response.data
  }

  async setCareers () {
    this.loading = true
    const [error, response] = await MainService.getCareers()
    this.loading = false
    if (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error al obtener las carreras'
      })
      return
    }
    this.careers = response.data
    this.career = response.data[0].name
  }

  async setUserData () {
    this.loading = true
    const [error, response] = await MainService.getUser(this.token)
    this.loading = false
    if (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error al prellenar formulario'
      })
      return
    }
    this.email = response.data.email
    this.incomplete = !response.data.is_client
    this.name = response.data.username
  }

  async register () {
    this.loading = true
    const [error] = await MainService.updateUser(this.token, {
      phone: this.phone,
      phone_country_code: this.phone_country_code,
      career: this.otherCareer ? this.otherCareer : this.career
    })
    this.loading = false
    if (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error al actulizar la información'
      })
      return
    }
    this.incomplete = false
  }
}
